<template>
	<div v-if="dataisload" class="modal fade" id="modal-wash-popup" tabindex="-1" ref="modalsize">
		<div class="modal-dialog" style="max-width: 800px">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title wash-modal-title">
						<a class="close" href="#" data-dismiss="modal">
							<i class="icon-close"></i>
						</a>
						<span>LAUNDRY</span>
					</h4>
				</div>
				<div class="modal-body">
					<div class="item-report">
						<div v-html="alldatas.CareLabelDesc"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "WashPopup",
	props: ["alldatas", "dataisload"],
	watch: {
		dataisload: function (val) {
			if (val) {
				this.$nextTick(() => {
					this.toggleSizeBlock();
				});
			}
		},
	},
	methods: {
		toggleSizeBlock: function () {
			const $modal = $(this.$refs.modalsize),
				$btnCollaspe = $modal.find(".size-guide__section >h2");
			$btnCollaspe.click(function (e) {
				e.preventDefault();
				const $selfContent = $(this).parent().find(".size-guide__content");
				if ($(this).hasClass("show")) return;
				$btnCollaspe.removeClass("show");
				$(this).addClass("show");
				$(".size-guide__content").slideUp("400");
				$selfContent.slideDown("400");
			});
		},
	},
};
</script>
